import { Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { URI } from 'src/app/settings/uri-constants';

@Component({
    selector: 'app-enterprise-links',
    templateUrl: './enterprise-links.component.html',
    styleUrls: ['./enterprise-links.component.css'],
})
export class EnterpriseLinksComponent implements OnInit {
    @Input() id!: string;

    isAdmin = false;
    sessionUser$ = this.loginService.sessionUser.asObservable();

    constructor(private loginService: LoginService) { }

    ngOnInit(): void {
        this.sessionUser$
            .pipe(take(1))
            .subscribe((user) => {
                if (user) {
                    this.isAdmin = user.isAdmin();
                }
            });
    }

    get enterpriseProfileLink(): string {
        return URI.getRouteNavPath('enterpriseProfile');
    }

    get enterpriseEmployeesLink(): string {
        return URI.getRouteNavPath('enterpriseEmployee');
    }

    get enterpriseTransactionsLink(): string {
        return this.isAdmin
            ? URI.getRouteNavPath('enterpriseTransactionsAdmin')
            : URI.getRouteNavPath('enterpriseTransactions');
    }

    get enterpriseWalletBalanceLink(): string {
        return this.isAdmin
            ? URI.getRouteNavPath('adminEnterpriseWalletBalance')
            : URI.getRouteNavPath('enterpriseWalletBalance');
    }

    get enterpriseSettingsLink(): string {
        return URI.getRouteNavPath('enterpriseSettings');
    }
}
